<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <!-- 缓存侧边栏主要页面，切换回来时秒开，避免每次重新挂载导致慢 -->
      <KeepAlive :include="['Creative', 'Assets', 'Generate', 'My', 'Membership', 'Tools']">
        <component :is="Component" />
      </KeepAlive>
    </router-view>

    <!-- 全局下载APP弹窗 -->
    <DownloadModal v-model="modalStore.showDownloadModal" />

    <!-- 全局个人设置弹窗 -->
    <PersonalSettingsModal
      v-model="modalStore.showPersonalSettingsModal"
      @saved="handleSettingsSaved"
    />

    <!-- 全局注销弹窗 -->
    <WriteOffModal v-model="modalStore.showWriteOffModal" />

    <!-- 全局素材上传须知弹窗 -->
    <MaterialUploadNoticeModal />

    <!-- 全局订单记录弹窗 -->
    <InspirationValueModal />

    <!-- 全局订阅管理弹窗 -->
    <SubscriptionManageModal />

    <!-- 全局新版本更新提示 -->
    <AppUpdateBanner />

    <!-- 全局官方消息抽屉 -->
    <MessageDrawer direction="ltr" :offset="110" />
  </div>
</template>

<script setup lang="ts">
import { useModalStore } from '@/stores/modal'
import { useWalletStore } from '@/stores/wallet'
import { useUserProfileStore } from '@/stores/userProfile'
import { useMembershipStore } from '@/stores/membership'
import { useMessageStore } from '@/stores/message'
import { useAppBasicConfigStore } from '@/stores/appBasicConfig'
import { useAppVersionStore } from '@/stores/appVersion'
import MessageDrawer from '@/components/MessageDrawer.vue'

// App根组件
const modalStore = useModalStore()
const walletStore = useWalletStore()
const userProfileStore = useUserProfileStore()
const membershipStore = useMembershipStore()
const messageStore = useMessageStore()
const appBasicConfigStore = useAppBasicConfigStore()
const appVersionStore = useAppVersionStore()

// 页面刷新时：已登录且刷新令牌有效则自动拉取钱包余额、当前用户信息、会员套餐、消息分类
void walletStore.fetchAccounts()
void userProfileStore.fetchDetail()
void membershipStore.fetchMemberships()
void messageStore.fetchCategories()
// 应用基础配置、新版本更新无需登录，刷新时直接拉取
void appBasicConfigStore.fetchConfig()
void appVersionStore.fetchUpdate()

// 个人设置保存后刷新用户信息
const handleSettingsSaved = async () => {
  await userProfileStore.fetchDetail()
}
</script>

<style lang="scss">
@import '@/styles/index.scss';

#app {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  font-family: NotoSans-bold;
}
</style>
